import { useAtom } from 'jotai';
import { SearchIcon } from 'lucide-react';

import { Input } from '@crossnokaye/ux-common/ckds';

import SelectionState from '@/features/clickhouse-trends/components/selections-sidebar/state/selections.state';

export const SelectionsSearchInput = () => {
  const [searchTerm, setSearchTerm] = useAtom(SelectionState.searchTerm);

  return (
    <Input
      icon={SearchIcon}
      onChange={(e) => setSearchTerm(e.target.value)}
      placeholder={'Search devices and points...'}
      value={searchTerm}
      clearable
    />
  );
};
